export const TOKEN_EXPIRADO = "Token Expirado";

/**
 * O admin da PLATAFORMA — `admin.clubdacotacao.com.br`, `admin.v2...`, com ou
 * sem esquema, com qualquer caminho ou query.
 *
 * Nunca e o login de um tenant: e o endereco que a versao antiga gravava
 * sozinha em `loginURL` quando o tema nao trazia URL propria. Reconhecido aqui
 * para ser DESCARTADO, senao vence VUE_APP_RETURN_ADDRESS para sempre naquele
 * navegador.
 *
 * Casa por HOST, e nao pela string inteira: a primeira versao desta guarda
 * comparava com um endereco exato e qualquer variacao escapava — barra no fim,
 * query, ou o `admin.v2`. O usuario continuava caindo no admin.
 */
const PLATFORM_ADMIN = /^(https?:\/\/)?admin[^/]*\.clubdacotacao\.com\.br(\/|$|\?|#)/i

/** O valor gravado pode ou nao trazer o esquema; prefixar as cegas dobrava. */
function withScheme(url) {
    return /^https?:\/\//i.test(url) ? url : `https://${url}`
}

/**
 * Para onde a sessao volta quando o token cai.
 *
 * O whitelabel manda: um tenant volta para o login DELE, gravado em `loginURL`
 * ao abrir o app com `?theme=`. Sem tenant, vale VUE_APP_RETURN_ADDRESS.
 *
 * Duas armadilhas que ja quebraram isto em producao:
 *
 * - `https://${loginUrl}` as cegas, sobre um valor que ja vinha com esquema,
 *   produzia `https://https://...` — URL invalida, nao so destino errado.
 * - a chave e PERSISTENTE. Um endereco preso no localStorage vencia
 *   VUE_APP_RETURN_ADDRESS para sempre naquele navegador, entao trocar a
 *   variavel nao surtia efeito nenhum em quem ja tinha visitado o app.
 */
function verifyUrlToRedirect() {

    const loginUrl = (localStorage.getItem('loginURL') || '').trim()

    if (!loginUrl || PLATFORM_ADMIN.test(loginUrl)) {
        return process.env.VUE_APP_RETURN_ADDRESS
    }

    return withScheme(loginUrl)

}

export const REQUEST_CODE_SUCCESS = 200;
export const REQUEST_CODE_UNAUTHORIZED = 401;
export const REQUEST_CODE_TOO_MANY_REQUESTS = 429;

export const API_URL = process.env.VUE_APP_API_URL;
export const API_V3_URL = process.env.VUE_APP_API_V3_URL;

// Destino da troca de conta para fornecedor/admin: o seletor do cabecalho nao
// pode reabrir uma conta de fornecedor dentro do painel do cliente.
export const PROVIDER_URL = process.env.VUE_APP_PROVIDER_URL;
export const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export const PROJECT_ENV = process.env.VUE_APP_ENV;
// export const ROUTE_LOGIN                    = process.env.VUE_APP_RETURN_ADDRESS;
export const ROUTE_LOGIN = verifyUrlToRedirect();
export const ROUTE_HOME = "/cliente";
export const ROUTE_NEW_QUOTATION_REQUEST = "/cliente/cotacao/nova";
export const ROUTE_REPORTS = ROUTE_HOME + "/relatorios";
export const ROUTE_MONITORS = ROUTE_HOME + "/monitores/cotacoes";
export const ROUTE_SETTINGS = "/configuracoes";
export const ROUTE_MONITORS_WINNERS = ROUTE_MONITORS + "/vencedores";
export const ROUTE_LOGOUT = ROUTE_HOME + "/logout";
// import { store } from '@/store/store'

// function verifyUrlToRedirect() {
//     let loginURl = store.state.whitelabel.data.providers.loginURl;

//     if (loginURl) {
//         return loginURl
//     } else {
//         return process.env.VUE_APP_RETURN_ADDRESS
//     }

// }
